document.addEventListener('DOMContentLoaded',()=>{
  if(window.tfpApprovedLogo)document.querySelectorAll('.header__heading-logo').forEach(img=>{img.src=window.tfpApprovedLogo;img.srcset=''});
  document.querySelectorAll('.header__inline-menu a,.menu-drawer__navigation a').forEach(link=>{const label=link.textContent.trim().toLowerCase();if(label==='clearance'||label==='contact'){link.closest('li')?.remove();return}if(label==='clothes'){const walker=document.createTreeWalker(link,NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode()){if(/clothes/i.test(node.textContent))node.textContent=node.textContent.replace(/clothes/ig,'Apparel')}}});
  document.querySelectorAll('.product__description a[href*=\"P65Warnings\" i],.product__description a[href*=\"p65warnings\" i]').forEach(link=>{const row=link.closest('p,li');if(row)row.remove();else link.remove()});
  document.querySelectorAll('.product__description p,.product__description li').forEach(node=>{if(/cancer and reproductive harm|p65warnings/i.test(node.textContent))node.remove()});
  document.querySelectorAll('.product__description').forEach(description=>{
    const paragraphs=[...description.querySelectorAll('p')];
    paragraphs.forEach(node=>{
      const text=(node.textContent||'').replace(/\s+/g,' ').trim();
      if(/^technical characteristics:?$/i.test(text))node.classList.add('tfp-description-heading');
      if(/^[•·-]\s*/.test(text)||/^[a-z][a-z\s'’/&-]{1,34}:\s+\S/i.test(text)){
        node.textContent=text.replace(/^[•·-]\s*/,'');
        node.classList.add('tfp-description-spec');
      }
    });
    const firstSpec=description.querySelector('.tfp-description-spec');
    if(firstSpec&&!description.querySelector('.tfp-description-heading')){
      const heading=document.createElement('p');
      heading.className='tfp-description-heading';
      heading.textContent='TECHNICAL CHARACTERISTICS';
      firstSpec.before(heading);
    }
  });
  const nativeTitle=(document.querySelector('.product__title h1')?.textContent||'').trim().replace(/\s+/g,' ').toLowerCase();
  document.querySelectorAll('.product__description h1,.product__description h2,.product__description h3,.product__description h4').forEach(heading=>{
    const headingText=(heading.textContent||'').trim().replace(/\s+/g,' ').toLowerCase();
    if(nativeTitle&&(headingText===nativeTitle||headingText.startsWith(nativeTitle+' ')||headingText.startsWith(nativeTitle+' –')||headingText.startsWith(nativeTitle+' -')))heading.remove();
  });
  document.querySelectorAll('share-button,.share-button').forEach(node=>node.remove());
  const exoHandle=location.pathname.includes('/products/fishus-exo-set-uv-50');
  const replaceImage=(img,url)=>{if(!img||!url)return;img.src=url;img.srcset=url;img.removeAttribute('sizes')};
  if(exoHandle&&window.tfpExoGallery){
    document.body.classList.add('tfp-exo-square-gallery');
    document.querySelectorAll('.product__media-list .product__media-item').forEach((slide,index)=>replaceImage(slide.querySelector('img'),window.tfpExoGallery[index]));
    document.querySelectorAll('.thumbnail-list__item').forEach((thumb,index)=>replaceImage(thumb.querySelector('img'),window.tfpExoGallery[index]));
    document.querySelectorAll('.product-media-modal__content img').forEach((img,index)=>replaceImage(img,window.tfpExoGallery[index]));
  }
  document.querySelectorAll('.tfp-product-card--fishus-exo-set-uv-50 img').forEach(img=>replaceImage(img,window.tfpExoGallery?.[0]));
  document.querySelectorAll('media-gallery').forEach(gallery=>{
    const slides=[...gallery.querySelectorAll('.product__media-item[data-media-id]')];
    const thumbItems=[...gallery.querySelectorAll('.thumbnail-list__item[data-target]')].filter(item=>!item.classList.contains('is-filtered'));
    if(slides.length<2)return;
    const show=(target)=>{
      const active=slides.find(slide=>slide.dataset.mediaId===target)||slides[0];
      slides.forEach(slide=>{
        slide.classList.toggle('is-active',slide===active);
        if(slide!==active)slide.querySelector('video')?.pause();
      });
      thumbItems.forEach(item=>{
        const button=item.querySelector('button');
        if(item.dataset.target===active.dataset.mediaId)button?.setAttribute('aria-current','true');
        else button?.removeAttribute('aria-current');
      });
    };
    thumbItems.forEach(item=>item.querySelector('button')?.addEventListener('click',()=>show(item.dataset.target)));
    gallery.querySelectorAll('[data-tfp-native-prev],[data-tfp-native-next]').forEach(button=>button.addEventListener('click',()=>{
      const current=Math.max(0,slides.findIndex(slide=>slide.classList.contains('is-active')));
      const step=button.hasAttribute('data-tfp-native-prev')?-1:1;
      show(slides[(current+step+slides.length)%slides.length].dataset.mediaId);
    }));
  });
  const productTitle=(document.querySelector('.product__title h1')?.textContent||'').trim().toUpperCase();
  const compactLures=['ESPETRON','IPPAI','ESPETIT GOLIATH','WOBLY'];
  if(compactLures.includes(productTitle)){
    document.body.classList.add('tfp-compact-lure-pdp');
    const description=document.querySelector('.product__description');
    if(description&&!description.dataset.tfpOrganized){
      description.dataset.tfpOrganized='true';
      const video=description.querySelector('iframe,video');
      if(video){
        video.remove();
        if(productTitle==='ESPETIT GOLIATH'||productTitle==='WOBLY'){
          const mediaList=document.querySelector('.product__media-list');
          const firstSlide=mediaList?.querySelector('.product__media-item');
          if(mediaList&&firstSlide){
            const firstTarget=firstSlide.dataset.mediaId||firstSlide.id.replace(/^Slide-/,'');
            const sectionKey=firstTarget.replace(/-[^-]+$/,'');
            const target=sectionKey+'-tfp-lure-video';
            const slide=document.createElement('li');
            slide.id='Slide-'+target;
            slide.dataset.mediaId=target;
            slide.className='product__media-item grid__item slider__slide tfp-gallery-video-slide';
            const frame=document.createElement('div');
            frame.className='tfp-gallery-video';
            frame.append(video);
            slide.append(frame);
            mediaList.append(slide);
            const thumbs=document.querySelector('.thumbnail-list');
            if(thumbs){
              const thumb=document.createElement('li');
              thumb.className='thumbnail-list__item slider__slide';
              thumb.innerHTML='<button class="thumbnail global-media-settings tfp-video-thumb" type="button" data-target="'+target+'" aria-label="View product video"><span>VIDEO</span></button>';
              thumbs.append(thumb);
            }
            window.dispatchEvent(new Event('resize'));
          }
        }else{
          const media=document.createElement('div');
          media.className='tfp-lure-video';
          media.append(video);
          description.before(media);
        }
      }
      const paragraphs=[...description.querySelectorAll(':scope > p')].filter(p=>p.textContent.replace(/ /g,' ').trim());
      const groups={overview:[],performance:[],specs:[],species:[]};
      paragraphs.forEach((p,index)=>{
        const value=p.textContent.replace(/\s+/g,' ').trim();
        if(/size:|weight:|rattling|hooks? included/i.test(value))groups.specs.push(p);
        else if(/perfect for species|species like|target species/i.test(value))groups.species.push(p);
        else if(index===0)groups.overview.push(p);
        else groups.performance.push(p);
      });
      description.innerHTML='';
      groups.overview.forEach(p=>{p.classList.add('tfp-lure-lead');description.append(p)});
      const addPanel=(label,items,open=false)=>{
        if(!items.length)return;
        const details=document.createElement('details');
        details.className='tfp-lure-detail';
        if(open)details.open=true;
        const summary=document.createElement('summary');summary.textContent=label;
        const content=document.createElement('div');content.className='tfp-lure-detail-copy';
        items.forEach(item=>content.append(item));details.append(summary,content);description.append(details);
      };
      addPanel('WHY IT GETS HIT',groups.performance,true);
      addPanel('SPECS & RIGGING',groups.specs);
      addPanel('TARGET SPECIES',groups.species);
    }
  }
  const picker=document.querySelector('.product-form__input--swatch');const gallery=document.querySelector('.product__media-wrapper');if(picker&&gallery){const marker=document.createComment('tfp-picker-home');picker.before(marker);const placePicker=()=>{if(matchMedia('(max-width:749px)').matches)gallery.append(picker);else marker.parentNode?.insertBefore(picker,marker.nextSibling)};placePicker();addEventListener('resize',placePicker)}
  const source=document.querySelector('.product-form__submit');if(!source)return;const sticky=document.createElement('aside');sticky.className='tfp-sticky-buy';sticky.setAttribute('aria-label','Quick purchase');sticky.innerHTML='<div><strong></strong><small data-tfp-variant></small></div><button type="button">ADD TO CART ↗</button>';sticky.querySelector('strong').textContent=document.querySelector('.product__title h1')?.textContent?.trim()||'';const sync=()=>{const selected=document.querySelector('.product-form__input input[type=radio]:checked+label');sticky.querySelector('[data-tfp-variant]').textContent=selected?.textContent?.trim()||'';sticky.querySelector('button').disabled=source.disabled;sticky.querySelector('button').textContent=source.disabled?'SOLD OUT':'ADD TO CART ↗'};sticky.querySelector('button').addEventListener('click',()=>source.click());new MutationObserver(sync).observe(document.querySelector('main'),{attributes:true,childList:true,subtree:true});sync();document.body.append(sticky)
});
